import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tax-loss-harvesting',
  component: () => import('../../routes/TaxLossHarvestingCalculator.svelte'),
  card: {
    id: 'tax-loss-harvesting',
    title: 'Tax-Loss Harvesting',
    description: 'Calculate potential tax savings from harvesting investment losses to offset capital gains. See how much you could save by strategically realizing losses.',
    icon: 'account_balance',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/tax-loss-harvesting',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Tax-Loss Harvesting Calculator – Capital Gains Tax Savings Calculator',
    description: 'Free tax-loss harvesting calculator to calculate potential tax savings from harvesting investment losses. Enter your unrealized gain/loss, income, and filing status to see how much you could save by strategically realizing losses to offset capital gains.',
  },
};

export default meta;
